import React, {useEffect, useState} from 'react';
import {View, StyleSheet, ScrollView, SafeAreaView} from 'react-native';
import {CopyRight} from '../../utils/CopyRight';
import {appBackgroundWhiteBG} from '../../utils/utils';
import {LoginView} from './LoginView';
import {useSelector} from 'react-redux';
import {getIsBottomLogoToShown} from '../../redux/slices/ScreenOrientationSlice';

const NorcatLoginCard = props => {
   const isBottomLogoToShown = useSelector(getIsBottomLogoToShown);
   return (
      <SafeAreaView style={styles.container}>
         <View style={styles.cardContainer}>
            {props.isPortrait ? (
               <ScrollView style={{flex: 1, marginBottom: 0}}>
                  <View>
                     <LoginView isPortrait={props.isPortrait} />
                  </View>
               </ScrollView>
            ) : (
               <View
                  style={{
                     flex: 1,
                     marginLeft: 50,
                     marginRight: 50,
                     justifyContent: 'center',
                  }}>
                  <LoginView isPortrait={props.isPortrait} />
               </View>
            )}
            {props.isCopyrightShown &&
            props.isPortrait &&
            isBottomLogoToShown ? (
               <CopyRight
                  screenOrientation={!props.isPortrait}
                  isCopyrightShown={props.isCopyrightShown}
               />
            ) : null}
         </View>
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {
      backgroundColor: appBackgroundWhiteBG,
      flex: 1,
   },
   cardContainer: {
      marginTop: 24,
      marginEnd: 24,
      marginStart: 24,
      flex: 1,
   },
});

export default NorcatLoginCard;
